import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonGreenSizeS from './IconHorizonGreen_size_s';

const props: CreateIconArguments = {
  l: IconHorizonGreenSizeS,
  m: IconHorizonGreenSizeS,
  s: IconHorizonGreenSizeS,
  xs: IconHorizonGreenSizeS,
  name: 'IconHorizonGreen',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
